export default "__VITE_ASSET__BHNKbKKv__"